import { HttpAuth } from '../../config/Http'

export const actionTypes = {
    INDEX: 'TOP_INDEX',
    CLEAR: 'TOP_CLEAR',
    SUCCESS: 'TOP_SUCCESS',
    ERROR: 'TOP_ERROR'
}

export const clear = (payload) => ({
    type: actionTypes.CLEAR,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX 

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const index = (campaign_id = null, qtd = 3, initial = null, final = null) => dispatch => {
    return HttpAuth.post('/top', {
            'qtd' : qtd,
            'campaign_id' : campaign_id,
            'initial' : initial,
            'final': final
        })
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
}